import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTheme } from "./hooks/useTheme";
import { useLang } from "./hooks/useLang";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import ProjectDetail from "./components/ProjectDetail";
import Products from "./components/Products";
import ProductDetail from "./components/ProductDetail";
import About from "./components/About";
import Footer from "./components/Footer";
import "./styles/global.css";
import "./styles/theme.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  const { theme, changeTheme } = useTheme();
  const { lang, changeLang } = useLang();

  return (
    <>
      <ScrollToTop />
      <Nav theme={theme} changeTheme={changeTheme} lang={lang} changeLang={changeLang} />

      <Routes>
        <Route path="/" element={<Hero lang={lang} />} />
        <Route path="/projects" element={<Projects lang={lang} />} />
        <Route path="/projects/:slug" element={<ProjectDetail lang={lang} />} />
        <Route path="/products" element={<Products lang={lang} />} />
        <Route path="/products/:slug" element={<ProductDetail lang={lang} />} />
        <Route path="/about" element={<About lang={lang} />} />
      </Routes>

      <Footer lang={lang} />
    </>
  );
}
